import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { GROWTH_FACTOR_URL, IMAGES } from "../../data/config";
import { Reveal } from "../common/Reveal";

export const Hero = () => (
  <section className="relative flex min-h-[92vh] items-center overflow-hidden" data-testid="hero-section">
    <img
      src={IMAGES.hero}
      alt="Elegant corporate interior"
      className="absolute inset-0 h-full w-full object-cover"
    />
    <div className="absolute inset-0 bg-gradient-to-r from-cream via-cream/90 to-cream/10" aria-hidden="true" />
    <div className="container-site relative py-36">
      <Reveal className="max-w-2xl">
        <p className="eyebrow" data-testid="hero-eyebrow">Irma Ariandi — Consulting</p>
        <h1 className="mt-6 font-serif text-4xl leading-[1.08] tracking-tight text-navy sm:text-5xl lg:text-6xl" data-testid="hero-headline">
          GROWTH BEGINS WITH <span className="italic text-emerald">CLARITY.</span>
        </h1>
        <p className="mt-8 max-w-xl text-base leading-relaxed text-ink/75 sm:text-lg" data-testid="hero-subtext">
          We help people, businesses and organisations understand where they
          are, discover what is holding them back, and build the next move
          forward.
        </p>
        <div className="mt-12 flex flex-wrap items-center gap-4">
          <a href={GROWTH_FACTOR_URL} target="_blank" rel="noreferrer" className="btn-primary" data-testid="hero-primary-cta">
            Diagnose Your Growth <ArrowUpRight className="h-4 w-4" strokeWidth={1.5} />
          </a>
          <Link to="/contact" className="btn-outline" data-testid="hero-secondary-cta">
            Work With Us <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
